import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { openStoreSwitchModalAction } from 'reducks/modal/actions'

const openStoreSwitchModal = (
  storeName: string,
  storeRef: FirebaseDocRefType | undefined,
  storeManufacturerRef: FirebaseDocRefType | undefined,
  shopRef: FirebaseDocRefType | undefined
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(openStoreSwitchModalAction(storeName, storeRef, storeManufacturerRef, shopRef))
  }
}

export default openStoreSwitchModal
